import { useState } from 'react';

import { noop } from 'lodash';

type UseDialogWithoutUIProps = {
  onOpen?: typeof noop;
  onClose?: typeof noop;
};

const useDialogWithoutUI = ({ onOpen = () => {}, onClose = () => {} }: UseDialogWithoutUIProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  const handleOpen = () => {
    onOpen?.();
    setIsOpened(true);
  };

  const handleClose = () => {
    onClose?.();
    setIsOpened(false);
  };

  return {
    isOpened,
    onOpen: handleOpen,
    onClose: handleClose,
  };
};

export default useDialogWithoutUI;
